// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UsDdmT5Oube7s36ruDzs {
    padding: 16px;
    border-bottom: 1px solid #E5E5E5;
}

.g1l3GQnlQVPrjKD4UZly {
    margin-top: 0;
    font-size: 16px;
}

.K93wlOZgIfzv9Cqflpe1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.K93wlOZgIfzv9Cqflpe1 + .K93wlOZgIfzv9Cqflpe1 {
    margin-top: 16px;
}

.Se5iNBjjfmCWjaPadB7y, .cjiKS7oVanMW5J4qMouU {
    margin: 0;
}

.cjiKS7oVanMW5J4qMouU {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    font-size: 14px;
}

.joh9CKeaw3MPGVsb7Hq1 p {
    text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardWallet/DashboardWalletSociety/DashboardWalletSocietyHistory/DashboardWalletSocietyHistory.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mDAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["@value colors: \"../../../../../components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-text-subtle from colors;\n\n.history {\n    padding: 16px;\n    border-bottom: 1px solid #E5E5E5;\n}\n\n.title {\n    margin-top: 0;\n    font-size: 16px;\n}\n\n.item {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.item + .item {\n    margin-top: 16px;\n}\n\n.shares, .status {\n    margin: 0;\n}\n\n.status {\n    color: color-text-subtle;\n    font-size: 14px;\n}\n\n.text p {\n    text-align: right;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../../components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"history": `UsDdmT5Oube7s36ruDzs`,
	"title": `g1l3GQnlQVPrjKD4UZly`,
	"item": `K93wlOZgIfzv9Cqflpe1`,
	"shares": `Se5iNBjjfmCWjaPadB7y`,
	"status": `cjiKS7oVanMW5J4qMouU`,
	"text": `joh9CKeaw3MPGVsb7Hq1`
};
export default ___CSS_LOADER_EXPORT___;
